(function ($) {
    'use strict';

    var prfx = 'acom';

    acom_app.views.Subscribe = Backbone.View.extend({
        el: '#acom_subscribe',
        template: _.template($('#' + prfx + '-subscribe-template').html()),
        initialize: function () {
            this.model = acom_app.models.settings
        },
        bindEvents: function () {
            var _this = this
            var $el = this.$('.acom-subscribe-form')
            var $form = $el.find('form')

            $form.on('submit', function (e) {
                e.preventDefault();

                $el.addClass('loading-in-progress')

                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: acom_localize.ajaxurl,
                    data: {
                        'action': 'acom_subscribe',
                        'email': $('#acom_subscribe_email').val(),
                        'security': $('#acom_security').val()
                    },
                    success: function (data) {
                        setTimeout(function () {
                            $el.removeClass('loading-in-progress')

                            if (data.status == 'subscribed') {
                                $el.addClass('status-visible success')
                                _this.$('.acom-subscribe-success')
                                    .text(data.detail)

                                setTimeout(function () {
                                    $el.removeClass('status-visible success')
                                }, 3000)
                            } else {
                                $el.addClass('status-visible fail')
                                _this.$('.acom-subscribe-fail')
                                    .text(data.detail)

                                setTimeout(function () {
                                    $el.removeClass('status-visible fail')
                                }, 4000)
                            }
                        }, 1000)
                    }
                });

            });
        },
        render: function () {
            this.close()

            var html = this.template(this.model.toJSON());
            this.$el.append(html)

            this.bindEvents()

            return this
        },
        close: function () {
            $('#acom_subscribe').html('')
            this.unbind()
        }
    })
})(jQuery)